var __jsx = React.createElement;
import React, { useContext } from 'react';
import Map from '@spa/offer/components/Map';
import { ModalGlobalStyle } from './styles';
import Modal from '@spa/shared/components/Modal';
import { MediaContext } from '@spa/shared/contexts/media';
var MapViewModal = function MapViewModal(_ref) {
  var _ref$onClose = _ref.onClose,
    onClose = _ref$onClose === void 0 ? function () {} : _ref$onClose;
  var _useContext = useContext(MediaContext),
    is = _useContext.is;
  return __jsx(Modal, {
    onClose: onClose,
    withHeader: false,
    className: "map"
  }, __jsx(ModalGlobalStyle, null), __jsx(Map, {
    zoom: is.mobile ? 17 : 18,
    zoomSide: 'bottom-left',
    containerId: "modal-map",
    withoutControls: is.mobile
  }));
};
export default MapViewModal;